import { render, staticRenderFns } from "./LightsShadows.vue?vue&type=template&id=6ee04708&scoped=true&"
import script from "./LightsShadows.vue?vue&type=script&lang=js&"
export * from "./LightsShadows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee04708",
  null
  
)

export default component.exports